module.exports = __webpack_public_path__ + "img/image24@3x.48a2d530.png";